<script>
import CurrentTopicComponent from './currentTopicComponent'
import TopicComponent from './topicComponent'
import { MessageType } from './constants';
import { ActionCableService } from './services';
import { Duration } from 'luxon';
import draggable from 'vuedraggable'
import operationStore from './operationStore.vue';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    components:{
        'vue-topic-component': TopicComponent,
        'vue-current-topic-component': CurrentTopicComponent,
        'vue-draggable': draggable
    },
    data(){
        return {
            pageHidden: false,
            show_pending: true,
            isOpenTooltip: false,
            meetTimerDuration: 0,
            meetTimerInterval: {},
        }
    },
    computed:{
        actionHanlderDecider: function(message){
            return {
                [MessageType.SUBSCRIBED]: this.onSubscribe,
                [MessageType.CHOOSE_TOPIC]: this.onChooseTopic,
                [MessageType.CHANGE_TOPIC_DURATION]: ()=>{},
                [MessageType.CHANGE_TOPIC_POSITION]: this.onChangeTopicPosition,
                [MessageType.START_TOPIC]: this.onStartTopic,
                [MessageType.PAUSE_TOPIC]: ()=>{},
                [MessageType.FINISH_TOPIC]: this.onFinishTopic,
                [MessageType.FINISH_MEET]: this.onFinishMeet,
                [MessageType.CREATE_COMMENT]: this.onCreateComment,
                [MessageType.USER_ENTER]: this.onUserEnter,
                [MessageType.USER_LEFT]: this.onUserLeft
            };
        },
        displayStartedTime(){
            var show_time = ''
            if(this.meet.start_at.getHours() < 10){
                show_time += '0' + this.meet.start_at.getHours()
            }else{
                show_time += this.meet.start_at.getHours()
            }
            show_time += ':'
            if(this.meet.start_at.getMinutes() < 10){
                show_time += '0' + this.meet.start_at.getMinutes()
            }else{
                show_time += this.meet.start_at.getMinutes()
            }
            return show_time
        },
        displayFinishedTime(){
            var show_time = '';
            if(this.meet.finished_at.getHours() < 10){
                show_time += '0' + this.meet.finished_at.getHours()
            }else{
                show_time += this.meet.finished_at.getHours()
            }
            show_time += ':'
            if(this.meet.finished_at.getMinutes() < 10){
                show_time += '0' + this.meet.finished_at.getMinutes()
            }else{
                show_time += this.meet.finished_at.getMinutes()
            }
            return show_time
        },
        canStartMeet(){
            return !this.meet.start_at && !this.meet.finished_at;
        },
        canEndMeet(){
            return this.meet.start_at && !this.meet.finished_at
        },
        ...mapState('operationModule',['meet', 'users', 'clockRunning', 'topics', 'currentUsers']),
        ...mapGetters('operationModule',['currentTopic', 'findTopic', 'findUser', 'availableTopics', 'pendingTopics', 'finishedTopics', 'actionType', 'actionData', 'userIsOnline', 'nonParticipantUsers'])
    },
    channels: {
        OperationChannel: {
            received(message) {
                this.setAction(message)
                var actionHandler = this.actionHanlderDecider[this.actionType];
                actionHandler(message);
            }
        }
    },
    beforeMount() {
        this.$store.registerModule('operationModule', operationStore);
        ActionCableService.init({vue: this});
        this.getInitialData();
        this.subscribeCable();

        window.onblur = () => this.pageHidden = true;
        window.onfocus = () => {
            if (this.pageHidden){
                window.location.href = this.currentUrl()
            }
        }
    },
    methods: {
        unsubscribeCable(){
            ActionCableService.unsubscribe();
        },
        subscribeCable(){
            ActionCableService.subscribe({meetId:  this.meet.id});
        },
        getInitialData() {
            var _meet = JSON.parse(this.$attrs['data-meet']);
            var _topics = JSON.parse(this.$attrs['data-topics']);
            var _users = JSON.parse(this.$attrs['data-users']);

            this.initStore({meet: _meet, topics: _topics, users: _users});
            if(this.meet.start_at != null){
                this.startMeet(new Date(this.meet.start_at));
                this.meetTimerDuration = (new Date() - this.meet.start_at)/1000
                if(!this.meet.finished_at){
                    this.meetTimerInterval = setInterval(() => {this.meetTimerDuration += 1;}, 1000);
                    this.startClock();
                }else{

                    this.meetTimerDuration = (this.meet.finished_at - this.meet.start_at)/1000
                }
            }
        },
        onSubscribe(message){
            this.setCurrentTopicId(this.actionData.current_topic_id);
            this.actionData.current_users.forEach(user=>{
                this.insertCurrentUser(user);
            })
        },
        onChooseTopic(message){
            this.setCurrentTopicId(this.actionData.topic.id);
            ActionCableService.startTopic();
        },
        onChangeTopicPosition(message){
            this.actionData.positions_data.forEach(position_data => {
                this.changeTopicPosition(position_data.topic_id, position_data.position)
            });
        },
        onStartTopic(){
            if(!this.meet.start_at){
                this.startMeet();
            }
            this.startTopic(this.currentTopic.id);
            this.startMeetTimer();
        },
        onFinishTopic(){
            this.finishTopic(this.currentTopic.id);
            if(this.pendingTopics.length > 0 && !this.meet.finished_at){
                ActionCableService.chooseTopic({topicId: this.pendingTopics[0].id});
            } else {
                this.setCurrentTopicId(null);
            }
        },
        onFinishMeet(){
            if(!this.meet.finished_at){
                this.finishMeet();
            }
            this.stopMeetTimer();
        },
        onCreateComment(){
            this.insertComment({topicId: this.currentTopic.id, comment: this.actionData.comment});
        },
        onUserEnter(){
            this.insertCurrentUser({id: this.actionData.id, name: this.actionData.name});
        },
        onUserLeft(){
            this.removeCurrentUser({id: this.actionData.id, name: this.actionData.name});
        },
        viewPendingTopics(){
            this.show_pending = true;
        },
        viewEndedTopics(){
            this.show_pending = false;
        },
        clockTimeDisplay(){
            return Duration.fromObject({ seconds: this.meetTimerDuration }).toFormat('hh:mm:ss');
        },
        changeTopicPosition(event){
            var topic = this.pending_topics[event.newIndex]
            ActionCableService.changeTopicPosition({topicId: topic.id, position: event.newIndex});
        },
        startMeetNow(){
            if(this.topics.length > 0){
                this.startMeetTimer();
                this.chooseNextTopic();
            }
        },
        finishMeetNow(){
            ActionCableService.finishMeet();
        },
        startMeetTimer(){
            if (!this.clockRunning) {
                this.startClock();
                this.meetTimerInterval = setInterval(() => {
                    this.meetTimerDuration += 1;
                    }, 1000);
            }

        },
        stopMeetTimer(){
            this.pauseClock()
            clearInterval(this.meetTimerInterval);

        },
        chooseNextTopic(){
            ActionCableService.chooseTopic({topicId: this.pendingTopics[0].id});
        },
        participantBoxClass(participantId){
            return {
                'participant-box': true,
                'participant-online': this.userIsOnline(participantId)

            }
        },
        ...mapActions('operationModule', ['initStore', 'setAction', 'setCurrentTopicId', 'changeTopicDuration', 'changeTopicPosition', 'startMeet', 'finishMeet', 'finishTopic', 'startTopic', 'startClock', 'pauseClock', 'insertComment', 'insertCurrentUser', 'removeCurrentUser'])
    }
}
</script>